import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import tr from 'date-fns/locale/tr';
import { IoNewspaperOutline } from "react-icons/io5";

import { getActiveEvents } from '../../api/eventsService';

registerLocale('tr', tr);

const DEFAULT_IMAGE = '/assets/images/example-post.jpg';

const Events = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 8;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [events, setEvents] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      setError(null);
      console.log('Fetching events with params:', {
        page: currentPage + 1,
        itemsPerPage,
        searchTerm,
        startDate,
        endDate
      });

      const response = await getActiveEvents(
        currentPage + 1, // API 1-tabanlı sayfalama kullanıyor
        itemsPerPage,
        searchTerm,
        "",
        startDate ? startDate.toISOString().split('T')[0] : undefined,
        endDate ? endDate.toISOString().split('T')[0] : undefined
      );

      console.log('Events response:', response);

      if (response.isSuccess && response.data) {
        setEvents(response.data.items || []);
        // Toplam sayfa sayısını API'den gelen değere göre ayarla
        const totalPages = Math.ceil(response.data.totalCount / itemsPerPage);
        setPageCount(totalPages);
        setError(null);
      } else {
        console.error('Failed to fetch events:', response);
        setError('Etkinlikler yüklenirken bir hata oluştu');
        setEvents([]);
        setPageCount(0);
      }
    } catch (error) {
      console.error('Error fetching events:', error);
      setError('Etkinlikler yüklenirken bir hata oluştu');
      setEvents([]);
      setPageCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [currentPage, searchTerm, startDate, endDate]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected); // ReactPaginate 0-tabanlı sayfalama kullanıyor
    window.scrollTo(0, 0); // Sayfa değiştiğinde en üste scroll
  };

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    setCurrentPage(0);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    setCurrentPage(0);
  };

  const handleImageError = (e) => {
    console.log('Image failed to load, using default image');
    e.target.src = DEFAULT_IMAGE;
  };

  return (
    <div className="events-page">

      <div className="events-tabs">
        <div className="container">
          <h1 className="page-title mt-4">Etkinlikler</h1>
          <div className="news-tabs-filter">
            <div className="news-tabs-filter-left">
              <div className="news-tabs-filter-left-item">
                <input 
                  type="text" 
                  placeholder="Etkinliklerde Ara" 
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <i className="pi pi-search"></i>
              </div>
            </div>
            <div className="news-tabs-filter-right">
              <div className="news-tabs-filter-right-item">
                <DatePicker
                  selected={startDate}
                  onChange={handleDateChange}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  locale="tr"
                  className="form-control"
                  placeholderText="Tarih Aralığı"
                  dateFormat="dd.MM.yyyy"
                  isClearable
                />
                <i className="pi pi-calendar"></i>
              </div>
            </div>
          </div>
          <div className="events-content">
            {loading ? (
              <div className="loading">Yükleniyor...</div>
            ) : error ? (
              <div className="alert alert-warning" role="alert">
                {error}
              </div>
            ) : events.length === 0 ? (
              <div className="text-center py-5">
                <p>Etkinlik bulunamadı.</p>
              </div>
            ) : (
              <div className="events-grid">
                {events.map((event) => (
                  <Link key={event.guid} to={`/etkinlikler/${event.urlTag}`}>
                    <div className="events-card">
                      <div className="events-card-image">
                        <img 
                          src={event.pictureUrl || DEFAULT_IMAGE} 
                          alt={event.header}
                          onError={handleImageError}
                        />
                        <div className="events-card-overlay">
                          <span className="events-card-date">
                            {new Date(event.date).toLocaleDateString('tr-TR')}
                          </span>
                          <span className="events-card-category">{event.location}</span>
                        </div>
                      </div>
                      <div className="events-card-content">
                        <h3 className="events-card-title">{event.header}</h3>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
          {!loading && !error && events.length > 0 && (
            <div className="pagination-container">
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
                forcePage={currentPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Events;
